import useApiHelpers from "@/composables/api/helpers";

export default () => {
  const { getRequest } = useApiHelpers();

  /**
   * Checks the url for id param to then call the getOrderInfo api
   * @param {any} callback
   * @returns {Boolean callback| Promise callback}
   * */

  const getApiOrder = () => {
    const params = new URLSearchParams(window.location.search);

    if (!params.has("id")) {
      return false;
    }
    return getRequest(`/getOrderInfo/${params.get("id")}`);
  };

  const getPAPIOrder = () => {
    const params = new URLSearchParams(window.location.search);

    if (!params.has("initId")) {
      return false;
    }
    return getRequest(`/getPAPIOrderInfo/${params.get("initId")}`);
  }

  const getMerchSettings = () => {
    return getRequest("/get-base-merchant-settings");
  };

  const getNotificationSettings = () => {
    return getRequest("/notifications");
  };

  return {
    getApiOrder,
    getMerchSettings,
    getNotificationSettings,
    getPAPIOrder,
  };
};
